export default __webpack_public_path__ + "static/media/icon_12.24c31417.png";